/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Member_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Permanently remove {name} from the member list? Historical tournament results that reference them are preserved." |
*
* @param {Member_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_delete_confirm = /** @type {((inputs: Member_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Delete_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer définitivement ${i?.name} de la liste des membres ? Les résultats historiques de tournoi qui y font référence sont conservés.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Eliminar permanentemente a ${i?.name} de la lista de miembros? Los resultados históricos de torneo que hacen referencia a él se conservarán.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Remover permanentemente ${i?.name} da lista de membros? Os resultados históricos de torneio que fazem referência a ele são preservados.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovere definitivamente ${i?.name} dalla lista dei membri? I risultati storici dei tornei che vi fanno riferimento vengono conservati.`)
	return /** @type {LocalizedString} */ (`Permanently remove ${i?.name} from the member list? Historical tournament results that reference them are preserved.`)
});